import { CheckboxList } from './checkbox-list.interface';

export interface MappedCheckboxList extends CheckboxList {
  isSelected?: boolean;
}
